// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CdcF9Ir6sPsEZ4Taztob6{display:inline;font-weight:400;font-size:1rem;margin-right:0}", "",{"version":3,"sources":["webpack://./resources/js/components/Price/PriceDescription/styles.module.scss"],"names":[],"mappings":"AAAA,uBACI,cAAA,CACA,eAAA,CACA,cAAA,CACA,cACJ","sourcesContent":[".price {\n    display: inline;\n    font-weight: 400;\n    font-size: 1rem;\n    margin-right: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"price": "CdcF9Ir6sPsEZ4Taztob6"
};
export default ___CSS_LOADER_EXPORT___;
